var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CCard',[_c('CCardHeader',[_c('strong',[_vm._v("Parts Requested")])]),(_vm.loading)?_c('TableCardLoader'):_c('div',[_c('PartRequestList',{attrs:{"items":_vm.items}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }